import React from 'react'
import PropTypes from 'prop-types'
import {withRouter} from 'next/router'
import Link from 'next/link'
import {translate} from 'react-i18next'

class LanguageSelection extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      changeLanguage: PropTypes.func.isRequired
    }).isRequired,

    router: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      query: PropTypes.object.isRequired,
      asPath: PropTypes.string.isRequired
    }).isRequired
  };

  render() {
    const {i18n} = this.props;
    if (i18n.language === 'en') {
      return (
        <Link href="/it">
          <a><img src="/static/images/flag-it.svg" height="15" alt="" /> Italiano</a>
        </Link>
      );
    }
    return (
      <Link href="/en">
        <a><img src="/static/images/flag-uk.svg" height="15" alt="" /> English</a>
      </Link>
    );
  }
}

export default translate()(withRouter(LanguageSelection))
